/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CalculatedInterestHeader from './component/CalculatedInterestHeader';
import './index.scss';

const CalculatedInterest = () => {
  const dispatch = useDispatch();
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/view-calculated-interest') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  React.useEffect(() => {
    const ele = document.querySelector('.nav-item-active a .tab-title');
    if (ele) {
      ele.textContent = 'View Calculated Interest';
    }
  }, []);

  return (
    <div className="tabs-container tBillPanel custom-check">
      <Spinner load={spinnerLoader} />

      <CustomSeparator parent1="Display" parent2="View Calculated Interest" />
      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && <DisplayErrorMessages errorMessages={errorMessages} />}
      <CalculatedInterestHeader
        errorMessages={errorMessages}
        setErrorMessages={setErrorMessages}
        setLoading={setLoading}
        setSuccessMessages={setSuccessMessages}
      />
    </div>
  );
};

export default CalculatedInterest;
